import { render, staticRenderFns } from "./site-header.vue?vue&type=template&id=63943877&scoped=true&"
var script = {}
import style0 from "./site-header.vue?vue&type=style&index=0&id=63943877&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63943877",
  null
  
)

export default component.exports